import { productsData } from '@/app/products/[slug]/products'

/**
 * The Accounts page renders this object and nothing else — every string comes
 * from products.ts, so the copy cannot drift from the source of truth.
 *
 * Section headings are verbatim fragments of `description` / `longDescription`
 * or neutral structural labels ("Overview", "What's included"). No claim about
 * the product is written anywhere in this folder.
 *
 * Two things on the page now sit outside this object: the h1 appends the
 * audience to `title` (see accounts-hero.tsx), and the FAQ section reads
 * ../faqs.ts. Both restate claims made elsewhere in the repo; neither
 * introduces a new one.
 */
export const ACCOUNTS = productsData.accounts

export const ACCOUNTS_MODULES = ACCOUNTS.modules
